import React from 'react';
import { useHeaderData } from '../../hooks/use-header-data';
import { flattenSideBarGroups, getSideBarItems, SIDE_BAR_LEVEL } from '../nav-drawer/helpers/flatten-side-bar-groups';
import { WhatsNewLink } from './whats-new-link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var WhatsNewSection = function WhatsNewSection(_ref) {
  var hidden = _ref.hidden;
  var headerData = useHeaderData();

  if (hidden || !(headerData !== null && headerData !== void 0 && headerData.whatsNew)) {
    return null;
  }

  var whatsNew = headerData.whatsNew;
  var whatsNewGroup = flattenSideBarGroups([whatsNew], SIDE_BAR_LEVEL.SECOND);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("hr", {}), getSideBarItems({
      items: whatsNewGroup
    }), /*#__PURE__*/_jsx(WhatsNewLink, {
      link: whatsNew === null || whatsNew === void 0 ? void 0 : whatsNew.showAllLink
    })]
  });
};